
import { includesValidator } from '../../common/utils/validator';

const IconStyles = {
  Filled: 'filled',
  Outlined: 'outlined',
};
const IconSizes = {
  ExtraSmall: 'extra-small',
  Small: 'small',
  Medium: 'medium',
};
const ICON_PREFIX = 'icon';
const ICON_SEPARATOR = '-';

export default {
  name: 'BbIcon',
  props: {
    name: String,
    type: {
      type: String,
      default: IconStyles.Outlined,
      validator: includesValidator(IconStyles),
    },
    size: {
      type: String,
      default: IconSizes.Medium,
      validator: includesValidator(IconSizes),
    },
  },
  computed: {
    iconClass() {
      return [ICON_PREFIX, this.name, this.type].join(ICON_SEPARATOR);
    },
  },
};
